<template>
  <div class="page-outputs">

    <h2>outputs</h2>
    <div class="outputs-content">
      <h3>ルーレットアプリの作成</h3>
      <p>意思決定が面倒臭くてルーレットで決めようとストアを見たら、気に入らないアプリだったので自作した。
        実装は2日くらいでデザインをずっと考えていた。ボタンの配置や色合いなどを考えるのが楽しかった。</p>


        <h3>数字を記憶するアプリ</h3>
        <p>常に頭を使う癖はつけようと思った。自分がそろばんをやっていて数字には自信がある。昔Javascriptで作成したゲームだがようやくストアでリリースできた。色合いは自分が好きなやつ。</p>


        <h3>カメラアプリ</h3>
        <p>これまた既存のアプリが気に入らないので作成した。ボタンがないのと、スワイプで撮影した写真が見れるのは完全に自分用のカスタマイズ</p>


        <h3>NSLayout Anchor</h3>
        <p>swiftでViewの開発をしている時のSnapkitのコード量が気になって自分で作成したExtension。現在は
          メソッドチェーンでオートレイアウトをかけるだけだが、制約のつけ忘れがない仕組みなど考え途中
        </p>

        <h3>MyQiita</h3>
        <p>
          git push hackerthonのリベンジ。同じOauth2認証をするアプリ。マークダウンの本文が帰ってきたのでJsで表示して見たけど、一手間かかりそう。
        </p>

        <h3>GitHubSearch</h3>
        <p>
          RxSwiftの勉強。marty-suzukiのリポジトリーを参考に作成した。
          インクリメント検索、viewからのinputでviewModelを初期化してviewmodelのプロパティーは全てoutputである。結合など色々と学んだ。
        </p>

        <h3>画像編集ライブラリ</h3>
        <p>
          CoreImageとCoreGraphicsを使った画像編集ツールを作成した。切り抜き、回転、お絵かき、ぼかし処理、フィルター処理、テキスト入力など基本的な編集が可能。切り抜きやテキスト入力のUIから全て自作した。Swiftでトーンカーブを利用する方法を調べるのに時間がかかった。
        </p>

      </div>

    </div>
</template>

<script>

  export default {
    name: 'Outputs',
    data() {
      return {
        show: true
      }
    }
  }

</script>

<style>

div.page-outputs {
  /* background-color: red; */
  text-align: center;
  margin-bottom: 100px;
}

div.outputs-content {
  display: inline-block;
}

/*  モバイルなら*/
@media screen and (max-width:781px) {
  div.outputs-content {
    width: 90%;
  }
}

/*  WEBなら*/
@media screen and (min-width:781px) {
  div.outputs-content  {
    width: 60%;
  }
}

div.outputs-content p, div.outputs-content h3 {
  text-align: left;
}
/* about-me classを指定したdivタグの子要素のpタグに適応 */
div.page-outputs p {
  font-size: 18px;
  color: darkgray;
}

div.page-outputs h2 {
  color: pink;
}

</style>



// WEBPACK FOOTER //
// src/pages/Outputs.vue